export const sampleConditionData = {
  activos: [
    {
      id: 1,
      nombre: "Servidor Principal",
      categoria: "Equipos Electrónicos",
      tiempoUso: 24, // meses
      valorAdquisicion: 12000,
      valorActual: 7200,
      condicion: "Bueno",
      indiceDepreciacion: 0.4,
      ubicacion: "Oficina Central Manizales"
    },
    {
      id: 2,
      nombre: "Estación de Trabajo 1",
      categoria: "Equipos Electrónicos",
      tiempoUso: 18,
      valorAdquisicion: 2500,
      valorActual: 1600,
      condicion: "Excelente",
      indiceDepreciacion: 0.35,
      ubicacion: "Oficina Central Manizales"
    },
    {
      id: 3,
      nombre: "Impresora Industrial",
      categoria: "Equipos Electrónicos",
      tiempoUso: 36,
      valorAdquisicion: 8000,
      valorActual: 3200,
      condicion: "Regular",
      indiceDepreciacion: 0.6,
      ubicacion: "Taller Manizales"
    },
    {
      id: 4,
      nombre: "Vehículo Utilitario 1",
      categoria: "Vehículos",
      tiempoUso: 30,
      valorAdquisicion: 35000,
      valorActual: 21000,
      condicion: "Bueno",
      indiceDepreciacion: 0.4,
      ubicacion: "Oficina Bogotá"
    },
    {
      id: 5,
      nombre: "Camión de Carga",
      categoria: "Vehículos",
      tiempoUso: 48,
      valorAdquisicion: 80000,
      valorActual: 32000,
      condicion: "Regular",
      indiceDepreciacion: 0.6,
      ubicacion: "Taller Manizales"
    },
    {
      id: 6,
      nombre: "Torno CNC",
      categoria: "Herramientas",
      tiempoUso: 12,
      valorAdquisicion: 25000,
      valorActual: 21250,
      condicion: "Excelente",
      indiceDepreciacion: 0.15,
      ubicacion: "Taller Manizales"
    },
    {
      id: 7,
      nombre: "Taladro Industrial",
      categoria: "Herramientas",
      tiempoUso: 40,
      valorAdquisicion: 5000,
      valorActual: 1500,
      condicion: "Necesita Reparación",
      indiceDepreciacion: 0.7,
      ubicacion: "Taller Manizales"
    },
    {
      id: 8,
      nombre: "Escritorio Ejecutivo",
      categoria: "Mobiliario",
      tiempoUso: 60,
      valorAdquisicion: 1200,
      valorActual: 600,
      condicion: "Bueno",
      indiceDepreciacion: 0.5,
      ubicacion: "Oficina Berlín"
    },
    {
      id: 9,
      nombre: "Estación de Trabajo 2",
      categoria: "Equipos Electrónicos",
      tiempoUso: 6,
      valorAdquisicion: 3000,
      valorActual: 2700,
      condicion: "Excelente",
      indiceDepreciacion: 0.1,
      ubicacion: "Oficina Múnich"
    },
    {
      id: 10,
      nombre: "Sistema de Seguridad",
      categoria: "Equipos de Seguridad",
      tiempoUso: 24,
      valorAdquisicion: 15000,
      valorActual: 9000,
      condicion: "Bueno",
      indiceDepreciacion: 0.4,
      ubicacion: "Oficina Central Manizales"
    },
    {
      id: 11,
      nombre: "Vehículo Ejecutivo",
      categoria: "Vehículos",
      tiempoUso: 12,
      valorAdquisicion: 45000,
      valorActual: 36000,
      condicion: "Excelente",
      indiceDepreciacion: 0.2,
      ubicacion: "Oficina Bogotá"
    },
    {
      id: 12,
      nombre: "Router Industrial",
      categoria: "Herramientas",
      tiempoUso: 36,
      valorAdquisicion: 7500,
      valorActual: 3000,
      condicion: "Regular",
      indiceDepreciacion: 0.6,
      ubicacion: "Taller Manizales"
    },
    {
      id: 13,
      nombre: "Montacargas",
      categoria: "Vehículos",
      tiempoUso: 54,
      valorAdquisicion: 40000,
      valorActual: 12000,
      condicion: "Necesita Reparación",
      indiceDepreciacion: 0.7,
      ubicacion: "Almacén Bogotá"
    },
    {
      id: 14,
      nombre: "Servidor Secundario",
      categoria: "Equipos Electrónicos",
      tiempoUso: 15,
      valorAdquisicion: 9000,
      valorActual: 6300,
      condicion: "Bueno",
      indiceDepreciacion: 0.3,
      ubicacion: "Oficina Berlín"
    },
    {
      id: 15,
      nombre: "Mesa de Conferencia",
      categoria: "Mobiliario",
      tiempoUso: 48,
      valorAdquisicion: 3500,
      valorActual: 1750,
      condicion: "Bueno",
      indiceDepreciacion: 0.5,
      ubicacion: "Oficina Central Manizales"
    },
    {
      id: 16,
      nombre: "Cámara de Seguridad",
      categoria: "Equipos de Seguridad",
      tiempoUso: 30,
      valorAdquisicion: 2000,
      valorActual: 800,
      condicion: "Regular",
      indiceDepreciacion: 0.6,
      ubicacion: "Almacén Bogotá"
    },
    {
      id: 17,
      nombre: "Generador Eléctrico",
      categoria: "Equipos Electrónicos",
      tiempoUso: 24,
      valorAdquisicion: 18000,
      valorActual: 10800,
      condicion: "Bueno",
      indiceDepreciacion: 0.4,
      ubicacion: "Taller Manizales"
    },
    {
      id: 18,
      nombre: "Compresor Industrial",
      categoria: "Herramientas",
      tiempoUso: 60,
      valorAdquisicion: 12000,
      valorActual: 2400,
      condicion: "Necesita Reparación",
      indiceDepreciacion: 0.8,
      ubicacion: "Taller Manizales"
    },
    {
      id: 19,
      nombre: "Laptop Ejecutiva",
      categoria: "Equipos Electrónicos",
      tiempoUso: 9,
      valorAdquisicion: 2200,
      valorActual: 1760,
      condicion: "Excelente",
      indiceDepreciacion: 0.2,
      ubicacion: "Oficina Múnich"
    },
    {
      id: 20,
      nombre: "Silla Ergonómica",
      categoria: "Mobiliario",
      tiempoUso: 24,
      valorAdquisicion: 800,
      valorActual: 480,
      condicion: "Bueno",
      indiceDepreciacion: 0.4,
      ubicacion: "Oficina Berlín"
    }
  ],
  // Tendencias de vida útil esperada por categoría
  vidaUtilEsperada: {
    "Equipos Electrónicos": 60, // meses
    "Vehículos": 96,
    "Herramientas": 84,
    "Mobiliario": 120,
    "Equipos de Seguridad": 72
  },
  // Proyecciones para análisis predictivo
  proyecciones: {
    mantenimientoNecesario: [
      {
        id: 7,
        nombre: "Taladro Industrial",
        fechaEstimadaMantenimiento: "2023-12-15",
        costoEstimado: 800,
        probabilidadFallo: 0.75
      },
      {
        id: 13,
        nombre: "Montacargas",
        fechaEstimadaMantenimiento: "2023-11-30",
        costoEstimado: 3500,
        probabilidadFallo: 0.85
      },
      {
        id: 18,
        nombre: "Compresor Industrial",
        fechaEstimadaMantenimiento: "2023-12-10",
        costoEstimado: 1800,
        probabilidadFallo: 0.9
      },
      {
        id: 3,
        nombre: "Impresora Industrial",
        fechaEstimadaMantenimiento: "2024-01-15",
        costoEstimado: 1200,
        probabilidadFallo: 0.6
      },
      {
        id: 16,
        nombre: "Cámara de Seguridad",
        fechaEstimadaMantenimiento: "2024-02-01",
        costoEstimado: 350,
        probabilidadFallo: 0.5
      }
    ]
  }
}; 